import {createGlobalStyle} from "styled-components/macro";
import {theme} from "../../theme";

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  body {
    margin: 60px 0 0 0;
    background-color: #C3C8CC;
    transition-property: all;
  }
`;

GlobalStyles.defaultProps = {
  theme: theme
}

export default GlobalStyles;